import { render, staticRenderFns } from "./homeBtns.vue?vue&type=template&id=a7ba5cfe&scoped=true&"
import script from "./homeBtns.vue?vue&type=script&lang=js&"
export * from "./homeBtns.vue?vue&type=script&lang=js&"
import style0 from "./homeBtns.vue?vue&type=style&index=0&id=a7ba5cfe&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7ba5cfe",
  null
  
)

export default component.exports